import { useTranslate } from "src/i18n";

export const useRateCardTranslate = () => {
  const { t } = useTranslate();

  return {
    configure: t("rates_widget.rate_card.configure", "Сконфигурировать"),
    discountBadge: (percent: number) => `-${percent}%`,
    countdownLabel: t(
      "rates_widget.discount_countdown.label",
      "Акция заканчивается через:",
    ),
    days: t("rates_widget.discount_countdown.days", "д"),
    hours: t("rates_widget.discount_countdown.hours", "ч"),
    minutes: t("rates_widget.discount_countdown.minutes", "м"),
    seconds: t("rates_widget.discount_countdown.seconds", "с"),
  };
};
